<template>
  <div>
    <vue-spinner v-if="loading"></vue-spinner>
    <breadcrumb-bar v-else
      :crumbs="[{name:'Administrative Settings'},{name: 'Data Import', link:'Imports Select'}, {name:'Import History', link:'Imports Select'}, {name: history.data.original_file || history.data.file}]"></breadcrumb-bar>
    <div class="col-md-12" v-if="!loading">
      <div class="row">
        <div class="portlet light">
          <div class="portlet-title">
            <div class="caption caption-md">
              <span class="caption-subject bold uppercase">Import History</span>
            </div>

            <div class="actions" v-if="history.data.failed_rows_count !== 0 || history.data.ignored_rows_count !== 0">
              <a class="btn btn-circle btn-icon-only btn-default"
                 style="width:35px; height:35px; padding: 6px;"
                 @click.prevent="exportHistory($route.params.id)">
                <img src="/static/global/img/csv-ico.svg" style="width:20px;">
              </a>
            </div>
          </div>
          <div class="portlet-body">
            <div>
              <p>
                {{ history.data.success_rows_count }} of {{ history.data.total_import_rows_count }} records have been
                imported successfully.
              </p>
              <div class="vue-good-table" style="margin-bottom:20px;"
                   v-if="history.data.failed_rows_count !== 0 || history.data.ignored_rows_count !== 0">
                <p>
                  <strong>Exceptions</strong>
                </p>
                <vue-good-table
                  v-if="history.columns && history.failedRows"
                  styleClass="vgt-table bordered vgt-scrollable"
                  :columns="history.columns"
                  :rows="history.failedRows"
                  :paginate="false"
                >
                </vue-good-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Breadcrumbs from '@/components/Breadcrumbs'
import Spinner from "../components/Spinner";

export default {
  data() {
    return {
      loading: false,
      columns: [
        {
          label: 'File Name',
          field: 'original_file',
          filterOptions: {enabled: false}
        },
        {
          label: 'Form Name',
          field: 'form.name',
          filterOptions: {enabled: false}
        },
        {
          label: 'Imported By',
          field: 'created.date.date',
          filterOptions: {enabled: false}
        },
        {
          label: 'Imported Status',
          field: 'status',
          filterOptions: {enabled: false}
        },
        {
          label: 'Actions',
          filterOptions: {enabled: false}
        }
      ],
    }
  },
  components: {
    'breadcrumb-bar': Breadcrumbs,
    'vue-spinner': Spinner
  },
  computed: {
    ...mapGetters({
      history: 'getImportsHistorySingle'
    })
  },
  methods: {
    ...mapActions({
      getHistory: 'IMPORTS_HISTORY_SINGLE_ACTION',
      resetHistorySingle: 'IMPORTS_RESET_HISTORY_SINGLE',
      exportHistory: 'IMPORTS_HISTORY_EXPORT_EXCEPTIONS'
    })
  },
  created() {
    this.resetHistorySingle()
  },
  mounted() {
    this.loading = true;
    this.getHistory({id: this.$route.params.id}).then(() => {
      this.loading = false;
    })
  },
  watch: {
    '$route.params.id': () => {
      this.loading = true;
      this.getHistory({id: this.$route.params.id}).then(() => {
        this.loading = fallse;
      })
    }
  }
}
</script>
<style scoped>
.capitalize {
  text-transform: capitalize;
}
</style>



// WEBPACK FOOTER //
// ImportsHistorySingle.vue?d4b584e2